require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-ribbon-cutting.json") })
        }
      }, "path---articles-tags-ribbon-cutting");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-ribbon-cutting!./.cache/json/articles-tags-ribbon-cutting.json
// module id = 1887
// module chunks = 231608221292675